import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";

import {getDepartment, getDivision, getNationality, getPosition, getReligion, getReportTo, getDocumentSubType, getUserData, getCostCenter, getUniformSizes, getNotification, bulkNotificationChange, getCurrentApprovers} from "api/services/common"


export const fetchDivision = createAsyncThunk("fetchDivision", async () => {
    const res = await getDivision();
    // console.log(res, "ressss")
    return res?.data
 });

 export const fetchPosition = createAsyncThunk("fetchPosition", async () => {
    // page_size is required: PositionList paginates at 100 (max_page_size 1000),
    // and this slice keeps only `payload.results` — so with no page_size any
    // company with more than 100 positions silently lost the rest from every
    // position dropdown, and the filter-chip resolvers that .find() a position
    // by id rendered a bare numeric id instead of its name.
    // NOTE: getPosition's signature is (id, params) — passing the params object
    // as the first argument drops it silently.
    const res = await getPosition(null, { page_size: 1000 });
    // console.log(res, "ressss")
    return res?.data
 });

 export const fetchNationality = createAsyncThunk("fetchNationality", async () => {
    const res = await getNationality();
    // console.log(res, "ressss")
    return res?.data
 });

 export const fetchDepartment = createAsyncThunk("fetchDepartment", async () => {
    const res = await getDepartment();
    // console.log(res, "ressss")
    return res?.data
 });

 export const fetchReligion = createAsyncThunk("fetchReligion", async () => {
    const res = await getReligion();
    // console.log(res, "ressss")
    return res?.data
 });


 export const fetchReportTo = createAsyncThunk("fetchReportTo", async () => {
    const res = await getReportTo();
    // console.log(res, "ressss")
    return res?.data
 });

 export const fetchDocumentSubType = createAsyncThunk("fetchDocumentSubType", async () => {
   const res = await getDocumentSubType();
   // console.log(res, "ressss")
   return res?.data
});

export const fetchUserData = createAsyncThunk("fetchUserData", async () => {
   const res = await getUserData();
   //console.log(res, "ressss")
   return res?.data
});

export const fetchCostCenterData = createAsyncThunk("fetchCostCenterData", async () => {
   const res = await getCostCenter();
   //console.log(res, "ressss")
   return res?.data
});


export const fetchUniformSizesData = createAsyncThunk("fetchUniformSizesData", async () => {
   const res = await getUniformSizes();
   return res?.data
});


export const fetchCurrentApproversData = createAsyncThunk("fetchCurrentApproversData", async () => {
   const res = await getCurrentApprovers();
   return res?.data
});


export const fetchNotificationData = createAsyncThunk("fetchNotificationData", async (params) => {
   const res = await getNotification(params);

   return res?.data
});


export const bulkNotificationChangeHandle = createAsyncThunk("bulkNotificationChangeHandle", async (params, { dispatch, getState }) => {
   await bulkNotificationChange(params);
   dispatch(fetchNotificationData(params))

   return params
});


export const commonSlice = createSlice({
    name: "common",
    initialState: {
     divisionLoading: false,
     division: [],
     divisionError: false,

     positionLoading: false,
     position: [],
     positionError: false,

     nationalityLoading: false,
     nationality: [],
     nationalityError: false,

     departmentLoading: false,
     department: [],
     departmentError: false,

     religionLoading: false,
     religion: [],
     religionError: false,

     reportToLoading: false,
     reportTo: [],
     reportToError: false,

     documentSubTypeLoading: false,
     documentSubType:[],
     documentSubTypeError:false,

     userDataLoading: false,
     userData:[],
     userDataError:false,


     costCenterLoading: false,
     costCenter:[],
     costCenterError:false,


     uniformSizesLoading: false,
     uniformSizes:[],
     uniformSizesError:false,


     currentApproversLoading: false,
     currentApprovers:[],
     currentApproversError:false,


     notificationLoading: false,
     notifications:[],
     notificationError:false,
     notificationCount:0,



     showToast: false,
     toastTitle: "",
     toastHeading: "",
     toastSubheading: "",
     toastType: "",

     
    },
    extraReducers: (builder) => {
     // Every `rejected` below MUST clear its loading flag, for the reason
     // spelled out on fetchPosition: these thunks are dispatched once at app
     // start (Routes/Approuter/index.jsx) and never retried on their own, so a
     // flag left true on failure stays true for the whole session. Consumers
     // read it as "still in flight" — FilterSelect does
     // `isDisabled={isDisabled || isLoading}`, permanently disabling the
     // control at "Loading…", and the filter-chip effects gate on `!xLoading`
     // and so never initialise at all. The matching `xError` is set on
     // rejection and cleared on both `pending` and `fulfilled`, so a retry
     // cannot leave a stale error behind.
     builder.addCase(fetchDivision.pending, (state, action) => {
      state.divisionLoading = true;
      state.divisionError = false;
     })
     builder.addCase(fetchDivision.fulfilled, (state, {payload}) => {
      state.divisionLoading = false;
      state.divisionError = false;
      state.division = payload.results;
     })
     builder.addCase(fetchDivision.rejected, (state, action) => {
      state.divisionLoading = false;
      state.divisionError = true;
     })



     // `rejected` MUST clear positionLoading. It is dispatched once, at app
     // start (Routes/Approuter/index.jsx), so a flag left true on failure stays
     // true for the life of the session with no retry to reset it. Every
     // consumer treats it as "still in flight": FilterSelect does
     // `isDisabled={isDisabled || isLoading}`, so each position picker in the
     // app sits permanently disabled reading "Loading…", and the filter-chip
     // effects across Employees/Documents/Resumes/Jobs/etc. gate on
     // `!positionLoading` and so never initialise at all. Clearing it lets those
     // run against an empty `position` array — the same path already taken when
     // a URL names an unknown position id — which is strictly better than never
     // running. Nothing reads positionLoading expecting it to stick true.
     // `positionError` is reset on pending so a retry can clear a stale error.
     builder.addCase(fetchPosition.pending, (state, action) => {
        state.positionLoading = true;
        state.positionError = false;
       })
       builder.addCase(fetchPosition.fulfilled, (state, {payload}) => {
        state.positionLoading = false;
        state.positionError = false;
        state.position = payload.results;
       })
       builder.addCase(fetchPosition.rejected, (state, action) => {
        state.positionLoading = false;
        state.positionError = true;
       })




     builder.addCase(fetchNationality.pending, (state, action) => {
        state.nationalityLoading = true;
        state.nationalityError = false;
       })
       builder.addCase(fetchNationality.fulfilled, (state, {payload}) => {
        state.nationalityLoading = false;
        state.nationalityError = false;
        state.nationality = payload;
       })
       builder.addCase(fetchNationality.rejected, (state, action) => {
        state.nationalityLoading = false;
        state.nationalityError = true;
       })



       builder.addCase(fetchDepartment.pending, (state, {payload}) => {
        // console.log(payload, "ACTIONNNNN")

        state.departmentLoading = true;
        state.departmentError = false;
       })
       builder.addCase(fetchDepartment.fulfilled, (state, {payload}) => {
        state.departmentLoading = false;
        state.departmentError = false;
        state.department = payload.results;
       })
       builder.addCase(fetchDepartment.rejected, (state, {payload}) => {
        state.departmentLoading = false;
        state.departmentError = true;
       })



       builder.addCase(fetchReligion.pending, (state, action) => {
        state.religionLoading = true;
        state.religionError = false;
       })
       builder.addCase(fetchReligion.fulfilled, (state, {payload}) => {
        state.religionLoading = false;
        state.religionError = false;
        state.religion = payload.results;
       })
       builder.addCase(fetchReligion.rejected, (state, action) => {
        state.religionLoading = false;
        state.religionError = true;
       })


       builder.addCase(fetchReportTo.pending, (state, action) => {
        state.reportToLoading = true;
        state.reportToError = false;
       })
       builder.addCase(fetchReportTo.fulfilled, (state, {payload}) => {
        state.reportToLoading = false;
        state.reportToError = false;
        state.reportTo = payload;
       })
       builder.addCase(fetchReportTo.rejected, (state, action) => {
        state.reportToLoading = false;
        state.reportToError = true;
       })


       builder.addCase(fetchDocumentSubType.pending, (state, action) => {
         state.documentSubTypeLoading = true;
         state.documentSubTypeError = false;
        })
        builder.addCase(fetchDocumentSubType.fulfilled, (state, {payload}) => {
         state.documentSubTypeLoading = false;
         state.documentSubTypeError = false;
         state.documentSubType = payload;
        })
        builder.addCase(fetchDocumentSubType.rejected, (state, action) => {
         state.documentSubTypeLoading = false;
         state.documentSubTypeError = true;
        })


        builder.addCase(fetchUserData.pending, (state, action) => {
         state.userDataLoading = true;
         state.userDataError = false;
        })
        builder.addCase(fetchUserData.fulfilled, (state, {payload}) => {
         state.userDataLoading = false;
         state.userDataError = false;
         console.log(payload, "payload")
         state.userData = payload;
        })
        builder.addCase(fetchUserData.rejected, (state, action) => {
         state.userDataLoading = false;
         state.userDataError = true;
        })



        builder.addCase(fetchCostCenterData.pending, (state, action) => {
         state.costCenterLoading = true;
         state.costCenterError = false;
        })
        builder.addCase(fetchCostCenterData.fulfilled, (state, {payload}) => {
         state.costCenterLoading = false;
         state.costCenterError = false;
         state.costCenter = payload.results;
        })
        builder.addCase(fetchCostCenterData.rejected, (state, action) => {
         state.costCenterLoading = false;
         state.costCenterError = true;
        })


        builder.addCase(fetchUniformSizesData.pending, (state, action) => {
         state.uniformSizesLoading = true;
         state.uniformSizesError = false;
        })
        builder.addCase(fetchUniformSizesData.fulfilled, (state, {payload}) => {
         state.uniformSizesLoading = false;
         state.uniformSizesError = false;
         state.uniformSizes = payload.results;
        })
        builder.addCase(fetchUniformSizesData.rejected, (state, action) => {
         state.uniformSizesLoading = false;
         state.uniformSizesError = true;
        })


        builder.addCase(fetchCurrentApproversData.pending, (state, action) => {
         state.currentApproversLoading = true;
         state.currentApproversError = false;
        })
        builder.addCase(fetchCurrentApproversData.fulfilled, (state, {payload}) => {
         state.currentApproversLoading = false;
         state.currentApproversError = false;
         // endpoint returns a plain array, not a paginated { results } object
         state.currentApprovers = payload || [];
        })
        builder.addCase(fetchCurrentApproversData.rejected, (state, action) => {
         state.currentApproversLoading = false;
         state.currentApproversError = true;
        })



        // `notificationLoading`/`notificationError` are shared with
        // bulkNotificationChangeHandle below, which is why both reset the error
        // on `pending`: otherwise a failed fetch leaves an error that a later,
        // successful bulk change never clears.
        builder.addCase(fetchNotificationData.pending, (state, action) => {
         state.notificationLoading = true;
         state.notificationError = false;
        })
        builder.addCase(fetchNotificationData.fulfilled, (state, {payload}) => {
         // console.log(payload.count, "payload")
         state.notificationLoading = false;
         state.notificationError = false;
         if(payload.previous){
            state.notifications = [...payload.results, ...state.notifications];
         }else{
            state.notifications = payload.results;
         }
         state.notificationCount = payload.count
        })
        builder.addCase(fetchNotificationData.rejected, (state, action) => {
         state.notificationLoading = false;
         state.notificationError = true;
        })


        builder.addCase(bulkNotificationChangeHandle.pending, (state, action) => {
         state.notificationLoading = true;
         state.notificationError = false;
        })
        builder.addCase(bulkNotificationChangeHandle.fulfilled, (state, action) => {
         state.notificationLoading = false;
         state.notificationError = false;
         // action.meta.arg.dispatch(fetchNotificationData({is_read: action?.is_read}));
         // if(payload?.action !== "read"){
         //    state.notifications = [];
         // }
        })
        builder.addCase(bulkNotificationChangeHandle.rejected, (state, action) => {
         state.notificationError = true;
         state.notificationLoading = false;
        

        })



    },
    reducers: {
        handleToast: (state, { payload: {showToast, toastTitle, toastHeading, toastSubheading, toastType} }) => {
            console.log("HHEEEEREEEEEEEEEEEE", showToast, toastTitle, toastHeading, toastSubheading, toastType)
            state.showToast = showToast
            state.toastTitle= toastTitle
            state.toastHeading= toastHeading
            state.toastSubheading = toastSubheading
            state.toastType = toastType

          },
          handleNotifications: (state, { payload }) => {
            console.log(payload, "JJJJ")
            state.notifications = [payload, ...state.notifications]

          }
      },
});

export const { handleToast, handleNotifications } = commonSlice.actions

export default commonSlice.reducer;
